export default __webpack_public_path__ + "static/media/13.d8ef4bb4.png";